<template>
	<div>
        <div :class="isShow?'detail-modal':'detail-modal hidden'">
            <div class='modal'>
                <div class='modal-head'>提示</div>
                <div class='modal-body'>订单金额发生变更，订单原金额为: <span style="color: #ff850d;"> {{Currency}} </span><span style="color: #ff850d; font-size:20px"> {{order.TotalAmount}} </span> ，订单新金额为: <span style="color: #ff850d;"> {{Currency}} </span><span style="color: #ff850d;font-size:20px"> {{Price}} </span> ，请再次确认！</div>
                <div class='modal-foot' style="display: flex;">
                    <div class='btn-l' style="color: #000;background-color: #f8f8f8;" @click="cancel">取消</div>
                    <div class='btn-l' @click="pay">确定</div>
                </div> 
            </div>
        </div>
		<div class="rule">
			<ul class="step">
    			<li class="step-arrow"></li>
        		<li class="step-text">填写订单</li>
        		<li class="step-arrow "></li> 
        		<li class="step-text ">订单支付</li>
        		<li class="step-arrow active"></li>
        		<li class="step-text active">订单完成</li>
    		</ul>
    		<div class="information">
    			<div class="pay">
    				<div class="pay-img">
                        <img src="../../assets/img/img19.png" height="80" width="80"/>
    				</div>
    				<div class="pay-content">
    					<p class="one">订单提交成功，准备去支付！</p>
    					<p class="two">请在10分钟之内完成支付，超时订单将被取消！</p>
    					<p class="three">最终订单状态以支付完成后订单状态为准！</p>
    				</div>
    			</div>
    		</div>
    		<div class="information-a">
    			<div class="pay">
    				<div class="price">
						<p>
                            订单总额<span class="rmb">{{Currency}}</span>
                            <span class="total">{{Price}}</span>
                            订单编号  {{OrderNO}}
                        </p>
    				</div>
    				<div class="info">
    					<p>{{bookInfo.details.HotelName||bookInfo.HotelName}}<span>({{bookInfo.details.HotelEName}})  {{bookInfo.RoomName}}</span></p>
                        <p>住客姓名： <span v-for="guest in order.Guest">{{guest.FirstName}} {{guest.LastName}} </span></p>
						<p>入离日期<span> {{bookInfo.CheckIn|delUTC|dateToYMDline}} </span>至<span> {{bookInfo.CheckOut|delUTC|dateToYMDline}} </span>{{bookInfo.days}}晚</p>
						<p>房间数量 {{bookInfo.RoomCount}}间</p>
    				</div>
    			</div>
    		</div>
			<div class="information-way">
    			<div class="pay-way">
    				<ul class="pay-bar">
    					<!-- <li :class="payType==1?'way active':'way'" @click="payType=1" v-if="account.Settlement!=1">信贷支付</li> -->
    					<!-- <li :class="payType==2?'way active':'way'" @click="payType=2">支付宝支付</li>
    					<li :class="payType==3?'way active':'way'" @click="payType=3">微信支付</li> -->
                        <li :class="payType==4?'way active':'way'" @click="payType=4">扫码支付</li>
    				</ul>
    			</div>
    			<!--信贷-->
    			<div class="pay-text" v-if="payType==1&&account.Settlement!=1">
    				<div class="company-a">
    					<div class="company-img">
    						<img src="../../assets/img/cn.png" alt="" />
    					</div>
    					<div class="company-box">
    						<p>客户名称：{{userInfo.Customer}}   <span>{{userInfo.CustomerNO}}</span></p>
    						<p>结算方式：{{userInfo.Settlement}}</p>
                            <p>账户状态：{{account.CreditsIsActived?'正常':'异常'}}</p>
    					</div>
    				</div>
    				<table>
    					<thead>
    						<tr>
    							<th width="10%">币种</th>
    							<th width="20%">总信用额度</th>
    							<th width="20%">可用额度</th>
    							<th width="10%">可订情况</th>
    							<th width="5%"></th>
    						</tr>
    					</thead>
						<tbody>
							<tr>
								<td>{{account.Currency}}</td>
								<td>{{account.TotalCredits}}</td>
								<td>{{account.TotalCredits-account.UsedCredits}}</td>
								<td>{{(account.TotalCredits-bookInfo.AdultPrice)>0?'额度满足':'额度不足'}} </td>
								<td>
                                    <i class="iconfont icon-fuxuankuang" v-if="(account.TotalCredits-bookInfo.AdultPrice)>0"></i>
                                    <i class="iconfont icon-close" v-else="(account.TotalCredits-bookInfo.AdultPrice)>0"></i>
                                </td>
							</tr>
						</tbody>
    				</table>
    				
    				<div class="prompt">
    					<p>温馨提示:</p>
    					<p>1.如额度扣减不成功,请刷新一下可用额度。</p>
						<p>2.如额度不足，可选择支付宝等支付工具，支付完成订单。</p>
						<p>3.如账户显示为“冻结”状态请联系龙腾捷旅财务人员</p>
    				</div>
    			</div>
    			<!--支付宝支付-->
    			<!-- <div class="wx-pay" v-if="payType==2">
    				<img src="./../../assets/img/zfb.png" alt="" />
    				<p>点击“去支付”后，将跳转到支付宝页面进行付款</p>
    			</div> -->
                <!--微信支付-->
                <!-- <div class="wx-pay" v-if="payType==3">
                    <img src="./../../assets/img/wx.png" alt="" />
                    <p>点击"去支付"后,请打开手机微信的"扫一扫",扫描二维码支付</p>
                </div> -->
                <div class="wx-pay" v-if="payType==4">
                    <img src="./../../assets/img/yop.png" alt="" />
                    <p>点击"去支付"后,请打开手机微信或支付宝的"扫一扫",扫描二维码支付</p>
                </div>
    			
    			<div class="button">
                    <div class="btn" @click="checkOrder" v-if="payType!=1">去支付</div>
    				<div class="btn disable" @click="alertMsg" v-if="payType==1 ">去支付</div>
    				<!-- <div class="return">返回修改订单</div> -->
    			</div>
    		</div>
		</div>

		<!--弹出框-->
		<div class="wx-modal" v-if="yoppayCode">
			<div class="modal">
				<div class="modal-head">扫码支付</div>
				<div class="modal-body">
					<div class="time"></div>
					<div class="ma">
                        <img :src="yoppayCode" />            
                    </div>
					<div class="info">
						<i class="iconfont icon-batch"></i>
						<span>打开手机微信或支付宝<br>扫一扫二维码</span>
					</div>
                    <div class="wechat-pay-status">
                        <div :class="isWxComplete?'ok disable':'ok '" @click="yoppaySuccess">支付完成</div>
                        <div class="no" @click="yoppayError">支付遇到问题</div>
                    </div>
				</div>
			</div>
		</div>
        <div class="wx-modal" v-if="wechatCode">
			<div class="modal">
				<div class="modal-head">微信支付</div>
				<div class="modal-body">
					<div class="time"></div>
					<div class="ma">
                        <img :src="wechatCode" />            
                    </div>
					<div class="info">
						<i class="iconfont icon-batch"></i>
						<span>打开手机微信<br>扫一扫二维码</span>
					</div>
                    <div class="wechat-pay-status">
                        <div :class="isWxComplete?'ok disable':'ok '" @click="wepaySuccess">支付完成</div>
                        <div class="no" @click="wepayError">支付遇到问题</div>
                    </div>
				</div>
			</div>
		</div>
        <form action="https://mapi.alipay.com/gateway.do" method="post" target="_blank" ref="form_export" >
            <input type='text' name="body" :value="alipayData.body"/>
            <input type="text" name="exter_invoke_ip" :value="alipayData.exter_invoke_ip" />
            <input type="text" name="extra_common_param" :value="alipayData.extra_common_param" />
            <input type="text" name="notify_url" :value="alipayData.notify_url" />
            <input type="text" name="out_trade_no" :value="alipayData.out_trade_no" />
            <input type="text" name="partner" :value="alipayData.partner" />
            <input type="text" name="payment_type" :value="alipayData.payment_type" />
            <input type="text" name="return_url" :value="alipayData.return_url" />
            <input type="text" name="seller_email" :value="alipayData.seller_email" />
            <input type="text" name="service" :value="alipayData.service" />
            <input type="text" name="show_url" :value="alipayData.show_url" />
            <input type="text" name="sign" :value="alipayData.sign" />
            <input type="text" name="sign_type" :value="alipayData.sign_type" />
            <input type="text" name="subject" :value="alipayData.subject" />
            <input type="text" name="total_fee" :value="alipayData.total_fee" />
            <input type="text" name="_input_charset" :value="alipayData._input_charset" />
        </form>
        <Modal v-show="modal.show" :config="modal" @ok="aliPaySuccess" @close="aliPayError"></Modal>
	</div>
</template>
<script>
    import Modal from './../../common/cmpnt/Modal/modal.vue'//跳转提示框
	export default{
		name:'bookComfirm',
        components:{Modal},
		data(){
			return{
                userInfo:this.dao.get('userInfo'),
                bookInfo:this.dao.get('bookInfo'),
                OrderNO:this.$route.query.OrderNO,
                Currency: this.dao.get('userInfo').Currency,
                payType:4,
                wechatCode:'',
                yoppayCode:'',
                alipayData:'',
                account:'',
                modal:{},
                order:'',
                Price:'',
                ReferencePrice:'',
                isWxComplete:false,
                time:'',//当前页面定时器缓存
                isShow:false
			}
		},
        methods:{
            cancel(){
                this.isShow = false
                this.$router.push('/orderDetails/'+this.OrderNO);
            },
            checkOrder(){
                var that = this;
                if(that.Currency!=='CNY'){
                    that.error({title:'提示',content:'抱歉，单单清支付仅支持人民币，请联系我司相关人员完成线下支付！'});
                    return
                }
                var param={
                    OrderNO:that.OrderNO
                }
                that.getRequest({ 
                    url: that.Api.getOrderDetails,
                    params:param
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.ReferencePrice = res.Result.TotalAmount;
                        if(that.ReferencePrice==that.Price){
                            this.pay()
                        }else{
                            that.isShow = true
                            that.Price = that.ReferencePrice
                        }
                    } else {
                        that.error({title:'提示',content:'获取订单状态出错，请刷新页面重试'});
                    }
                });
            },
            //选择支付方式
            pay(){
                this.isShow = false
                if(this.payType==2){
                    this.alipay(); 
                }else if(this.payType==3){
                    this.wxpay();
                }else if(this.payType==4){
                    this.YopPay();
                }
            },
            //信贷额度不足提示
            alertMsg(){
                this.error({title:'提示',content:'信贷额度不足，请使用其他方式完成支付'});
            },
            // 支付宝支付
            alipay(){
                var that=this;
                var param={
                    OrderNO:this.OrderNO
                }
                var tempwindow=window.open();
                that.getRequest({
                        url:that.Api.aliPay, 
                        params:param
                    }).then(res => {
                        if(res){
                            if(res.IsSuccess){
                                that.toAlipay(res.Result,tempwindow);
                                setTimeout(function(){
                                    that.getAliPayStatus();
                                },9000)
                            }else{

                                that.error({title:'提示',content:res.Msg||'不能预订'});
                                tempwindow.close();
                            }
                        }
                }); 
            },
            //微信支付
            wxpay(){
                var that=this;
                var param={
                    OrderNO:this.OrderNO
                }
                that.getRequest({
                        url:that.Api.wxPay, 
                        params:param
                    }).then(res => {
                        if(res){
                            if(res.IsSuccess){
                                that.wechatCode='data:image/jpg;base64,'+res.Result;
                           
                                setTimeout(function(){
                                    that.getWxPayStatus();
                                },9000)
                            }else{
                                this.error({title:'提示',content:res.Msg||'不能预订'});
                            }
                        }
                }); 
            },
            //易宝支付
            YopPay(){
                var that=this;
                var param={
                    OrderNO:this.OrderNO
                }
                that.getRequest({
                        url:that.Api.YopPay, 
                        params:param
                    }).then(res => {
                        if(res){
                            if(res.IsSuccess){
                                that.yoppayCode='data:image/jpg;base64,'+res.Result;
                                setTimeout(function(){
                                    that.getWxPayStatus();
                                },9000)
                            }else{
                                this.error({title:'提示',content:res.Msg||'不能预订'});
                            }
                        }
                }); 
            },
            //打开支付宝支付页面
            toAlipay(url,tempwindow){
        
                this.modal={
                    show:true,
                    content:'支付宝支付完成？',
                    isComfirm:true,
                    yes:'支付完成',
                    no:'支付遇到问题'
                }
                tempwindow.location=url;

                // newWindow.open(url)
                // window.open(url);

                return;
            },
            //轮循查询支付状态,isAliPay?'支付宝':'微信支付'
            // searchPayStatus(isAliPay,stop){
            //     if(stop)return;
            //     var that=this;
             
            //     if(isAliPay){
            //         that.getAliPayStatus();
            //     }else{
            //         that.getWxPayStatus();
            //     }
              
            // },
  
            //获取微信支付结果,isClick 指是否从弹出框进来
            getWxPayStatus(){
                var that=this;
                var param={
                    OrderNO:that.OrderNO
                }
         
                that.getRequest({
                        url:that.Api.getWxPayStatus,
                        params:param
                    }).then(res => {
                        if(res&&res.Result&&res.Result.OrderStatus&&res.Result.OrderStatus!=2&&res.Result.Paied){
                            that.isWxComplete=true;

                            that.$router.push('/bookComplete?OrderNO='+that.OrderNO); 
                        }else{
                            clearTimeout(that.time);
                            if(that.$route.name!='BookComfirm')return;
                            that.time=setTimeout(function(){
                                that.getWxPayStatus();
                            },3000)
                        }
                }); 

            },
            //获取支付宝支付结果
            getAliPayStatus(){
                var that=this;
                var param={
                    OrderNO:that.OrderNO
                }
                that.getRequest({
                        url:that.Api.getAliPayStatus,
                        params:param
                    }).then(res => {
                        if(res&&res.Result&&res.Result.OrderStatus&&res.Result.OrderStatus!=2&&res.Result.Paied){
                            that.isAliComplete=true;
                            that.$router.push('/bookComplete?OrderNO='+that.OrderNO);
                        }else{
                            clearTimeout(that.time);
                            if(that.$route.name!='BookComfirm')return;
                            that.time=setTimeout(function(){
                                that.getAliPayStatus(true);
                            },3000)
                        }
                }); 

            },
            //易宝支付已支付
            yoppaySuccess(){
                clearTimeout(this.time);
                if(!this.isWxComplete){
                    this.error({title:'提示',content:'订单处理中，请稍候'});
                    return;
                }
                this.$router.push('/bookComplete?OrderNO='+this.OrderNO);
            },
            //易宝支付出错
            yoppayError(){
                // this.wechatCode();
                this.$router.push('/orderDetails/'+this.OrderNO);
            },

            //微信支付已支付
            wepaySuccess(){
                clearTimeout(this.time);
                if(!this.isWxComplete){
                    this.error({title:'提示',content:'订单处理中，请稍候'});
                    return;
                }
                this.$router.push('/bookComplete?OrderNO='+this.OrderNO);
            },
            //微信支付出错
            wepayError(){
                // this.wechatCode();
                this.$router.push('/orderDetails/'+this.OrderNO);
            },
            //支付宝支付已支付
            aliPaySuccess(){
                this.modal.show=false;


                clearTimeout(this.time);
                this.$router.push('/bookComplete?OrderNO='+this.OrderNO);
            },
            //支付宝支付出错
            aliPayError(){
                this.modal.show=false
                this.$router.push('/orderDetails/'+this.OrderNO);
            },

            //获取非单单清用户的额度信息
            getAccount(){
                var that=this;
                that.getRequest({
                        url:that.Api.getAccount
                    }).then(res => {
                        if(res){
                            if(res.IsSuccess){
                                this.account=res.Result;
                                this.payType=(this.account.Settlement ==1)?'4':'1'
                            }else{
                                this.error({title:'提示',content:res.Msg||'不能预订'});
                            }
                        }
                }); 

            },
            // 获取订单信息
            getOrderData(){
                var that = this;
                var param={
                    OrderNO:that.OrderNO
                }
                that.getRequest({ 
                    url: that.Api.getOrderDetails,
                    params:param
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.order = res.Result;
                        that.Price = res.Result.TotalAmount;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    } else {
                        that.error({title:'提示',content:'获取订单状态出错，请刷新页面重试'});
                    }
                });
            },
        },
        mounted(){
            document.title='订单支付---订房易';
            //如果没有订单信息，则返回首页
            if(!this.bookInfo)this.$router.push('/');
            this.getOrderData();
        },
        destroyed(){
            this.dao.set('bookInfo','');//将当前缓存的订单信息清除，防止再次回来的情况
        }
	}
</script>
<style scoped>
.hidden {
    display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/bookComfirm.vue